export default __webpack_public_path__ + "static/media/logo_min2.ddbb63c9.png";